import { Component, AfterViewInit, OnInit } from '@angular/core';
import { ROUTES } from './menu-items';
import { RouteInfo } from './sidebar.metadata';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, NgIf } from '@angular/common';
//declare var $: any;
import { MenuService } from '../../services/menu.service';


import { AuthService } from '../../services/auth/auth.service';
import { TRANSLATIONS_EN } from 'src/app/i18n/translations.en';
import { TRANSLATIONS_HI } from 'src/app/i18n/translations.hi';
// sidebar.component.ts


// NavItem is just a type, never a value
interface NavItem {
  icon: string;
  label: string;
  route: string;
  active?: boolean;
  children?: NavItem[];
  expanded?: boolean;
}



@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, CommonModule, NgIf],
  templateUrl: './sidebar.component.html'
})

export class SidebarComponent implements OnInit {
  showMenu = '';
  showSubMenu = '';
  isAuthenticated: Boolean = false;
  public sidebarnavItems: RouteInfo[] = [];
  navItems: NavItem[] = [];

  // this is for the open close
  addExpandClass(element: string) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private menuService: MenuService,
    private authService: AuthService
  ) { }
  menuItems: any[] = [];
  currentDate: Date = new Date();
  currentUser: any;
  // End open close
  ngOnInit() {
    this.authService.currentUserSubject.subscribe((r) => {
      this.isAuthenticated = r

    });
    setInterval(() => {
      this.currentDate = new Date();
    }, 1000);

    this.authService.currentUserSubject.subscribe((user: any) => {
      this.isAuthenticated = !!user;
      this.userName = user?.firstName || 'Guest';
      this.roleName = user?.roleName || '';
    });
    this.navItems.forEach(item => {
      if (item.children && item.children.length > 0) {
        item.expanded = false;
      }
    });
    this.currentUser = this.authService?.currentUserValue;

    if (this.authService?.currentUserValue && this.authService.currentUserValue.roleId === 9 && this.authService.currentUserValue.certificatePath === null) {
    }
    else {
      if (this.isAuthenticated) {
        this.getMenu();
      }
    }
    //this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);



    //this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);



  }


  getMenu() {

    this.menuService.getMenuForHeader().subscribe({
      next: (response) => {
        this.menuItems = response.data;
        this.navItems = this.transformMenu(response.data);




      },
      error: (error) => {
        console.error('Error: ', error);
      },
    });
  }


  transformMenu(menuData: any[]): NavItem[] {
    return menuData
      .filter(item => item.isVisible !== false)
      .map(item => ({
        icon: item.className ? item.className.replace('bi ', '') : '',
        label: item.menuName,
        route: item.menuLink !== '#' ? item.menuLink : '',
        active: false,
        children: item.children && item.children.length > 0 ? this.transformMenu(item.children) : []
      }));
  }
  openIndex: number | null = null;

  setOpen(index: number) {
    this.openIndex = index;
  }

  closeMenu() {
    this.openIndex = null;
  }

  isOpen(index: number): boolean {
    return this.openIndex === index;
  }
  getVisibleMenu(item: any): any[] {

    return item.children?.filter((x: any) => x.isVisible === true) || [];
  }
  isEnglish = true;

  mobileMenuOpen = false;
  // Translations
  translations = TRANSLATIONS_EN;
  userName = this.authService?.currentUserValue?.firstName || 'Guest';
  roleName = this.authService?.currentUserValue?.roleName || '';
  toggleLanguage(): void {
    this.isEnglish = !this.isEnglish;
    this.translations = this.isEnglish
      ? TRANSLATIONS_EN
      : TRANSLATIONS_HI;
  }

}
